export function Logo({ compact = false }: { compact?: boolean }) {
  return (
    <div className="logo" style={compact ? { marginBottom: 8 } : undefined}>
      <div className="zh" style={compact ? { fontSize: 34 } : undefined}>
        江湖霸业
      </div>
      <div className="en" style={compact ? { fontSize: 15 } : undefined}>
        Jianghu Dominion
      </div>
      {!compact && <div className="sub">Legends of the Martial World</div>}
    </div>
  );
}
